// src/Tools/sharedTools.ts
// Shared tools used by both Policy and Claim flows

import { FunctionDeclaration } from "@google/genai";

//
// ───────────────────────────────────────────────
//  SHARED TOOLS (Generic tools used by both flows)
// ───────────────────────────────────────────────
//
// Note: Vehicle analysis tools are now flow-specific:
// - analyze_policy_vehicle_images (in policyTools.ts)
// - analyze_claim_vehicle_images (in claimTools.ts)
//
// This provides better separation and clearer flow control.

//
// ───────────────────────────────────────────────
//  EXPORT ALL SHARED TOOLS AS ARRAY
// ───────────────────────────────────────────────
//

export const SharedTools: FunctionDeclaration[] = [
  // No shared tools currently - all tools are flow-specific
  // Camera tools (start_camera_stream, take_vehicle_picture, request_close_camera) 
  // are in policyTools and could be moved here if needed for claims
];

